const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoSped(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44.18,
    height: 50,
    viewBox: "0 0 44.18 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Camada_2",
    "data-name": "Camada 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Camada_1-2",
    "data-name": "Camada 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ico-sped"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2652",
    "data-name": "Grupo 2652"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1283",
    "data-name": "Caminho 1283",
    d: "M34.94,11.25V47.43A2.57,2.57,0,0,1,32.37,50H2.57A2.57,2.57,0,0,1,0,47.43H0V11.25A2.57,2.57,0,0,1,2.57,8.68h29.8A2.57,2.57,0,0,1,34.94,11.25Z",
    style: {
      fill: "#4597d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1284",
    "data-name": "Caminho 1284",
    d: "M34.94,11.25v35.4H5.41a2.57,2.57,0,0,1-2.57-2.57V8.68H32.37A2.57,2.57,0,0,1,34.94,11.25Z",
    style: {
      fill: "#5fa8dd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1285",
    "data-name": "Caminho 1285",
    d: "M42.35,39.65,13.84,48.3a2.57,2.57,0,0,1-3.2-1.71L.14,12a2.57,2.57,0,0,1,1.71-3.2l.56-.17,28-8.48a2.57,2.57,0,0,1,3.2,1.71L43.83,35.67l.24.78A2.57,2.57,0,0,1,42.35,39.65Z",
    style: {
      fill: "#97c8ed"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1286",
    "data-name": "Caminho 1286",
    d: "M43.83,35.66l-28,8.48a2.57,2.57,0,0,1-3.2-1.71L2.4,8.59l28-8.48a2.58,2.58,0,0,1,3.2,1.71Z",
    style: {
      fill: "#c3dff6"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2281",
    "data-name": "Grupo 2281"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1287",
    "data-name": "Caminho 1287",
    d: "M18.55,17.32c1.15.08,1.72.15,2,1s-.05,1.22-.89,1.47a1.62,1.62,0,0,1-1.49-.18.93.93,0,0,0-.79-.18,1,1,0,0,0-.57,1.2c.21.71,1.31,1.16,2.52,1.06l.09.3a1,1,0,0,0,1.83-.55h0l-.1-.33a2.74,2.74,0,0,0,1.16-3.4,3.17,3.17,0,0,0-3.36-2.28h-.11c-1-.06-1.47-.11-1.65-.7a.72.72,0,0,1,.15-.78,1.94,1.94,0,0,1,.77-.42,2.23,2.23,0,0,1,1.2-.06,1.18,1.18,0,0,0,.56,0,1,1,0,0,0,.56-1.2c-.24-.81-1.49-.73-2.16-.62l-.09-.31a1,1,0,1,0-1.82.55h0l.12.42a2.49,2.49,0,0,0-1.05,3C16,17.16,17.4,17.25,18.55,17.32Z",
    style: {
      fill: "#4597d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1288",
    "data-name": "Caminho 1288",
    d: "M34,21.72a.75.75,0,0,0-.95-.5L11.35,27.79a.76.76,0,0,0-.5.95.75.75,0,0,0,.72.54.78.78,0,0,0,.22,0l21.68-6.58A.77.77,0,0,0,34,21.72Z",
    style: {
      fill: "#4597d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1289",
    "data-name": "Caminho 1289",
    d: "M35.24,25.89a.75.75,0,0,0-.94-.5L12.62,32a.76.76,0,0,0,.22,1.49.83.83,0,0,0,.22,0l21.68-6.58A.75.75,0,0,0,35.24,25.89Z",
    style: {
      fill: "#4597d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1290",
    "data-name": "Caminho 1290",
    d: "M36.51,30.07a.77.77,0,0,0-.95-.51L13.88,36.14a.76.76,0,0,0,.23,1.48.83.83,0,0,0,.22,0L36,31A.76.76,0,0,0,36.51,30.07Z",
    style: {
      fill: "#4597d3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1291",
    "data-name": "Caminho 1291",
    d: "M37.78,34.24a.77.77,0,0,0-1-.51L15.15,40.31a.76.76,0,0,0,.22,1.49.54.54,0,0,0,.22,0l21.68-6.57a.77.77,0,0,0,.51-.95Z",
    style: {
      fill: "#4597d3"
    }
  })), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_1292",
    "data-name": "Caminho 1292",
    d: "M11.88,5.72l-1.45.44a3.39,3.39,0,0,0-6.6,1.08V16a2,2,0,0,0,4,0V7.26A.53.53,0,0,0,7.72,7a.61.61,0,0,0-1.15.28V14.8a.76.76,0,1,1-1.52,0V7.26a2.13,2.13,0,0,1,4.13-.73,2,2,0,0,1,.13.73V16a3.5,3.5,0,0,1-7,0h0V7.24a4.91,4.91,0,0,1,9.58-1.52Z",
    style: {
      fill: "#287fc2"
    }
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSped);
export default __webpack_public_path__ + "static/media/ico-sped.cf00d48408abee2943e803baf8184e5f.svg";
export { ForwardRef as ReactComponent };